// import VideoTemplate from '../../../component/template/VideoTemplate.js'
import Webview from "../../../component/native/visible/Webview";
import PlayerView from "../../../component/native/visible/PlayerView";
import App from "../../../App";
import {getFilePathByRemoteUrl} from '@src/common/util'
import Dialog from "../../../component/visible/Dialog"
import SimpleBanner from "../../../component/visible/SimpleBanner"
import Message from '../../../../class/Message'
import SingleOfferTemplate from "../../../component/template/SingleOfferTemplate";

export default class IframeSingleDemo extends SingleOfferTemplate {
    constructor(...props) {
        super(...props);

        (function(){
            var timer = 1
            window.addEventListener('message', (e)=>{
                console.log("iframe 获取到 message====>",e, location.href)
                const {action, data} = e.data
                if(action==='mofClick'){
                    document.getElementById('msg').innerHTML += (data.msg+' '+timer+'<br/>')
                    console.log('大模版发来数据：', data.initData, data)
                    timer++
                }
            })
        })();
        document.body.addEventListener('touchstart', ()=>{
            parent.postMessage({
                action: 'subClick',
                data: '子模版向大模版发送消息'
            }, '*')
        }, false)
    }


    initComponents() {
        super.initComponents()
    }

    adShowed() {
        super.adShowed()
        // this.playerView.play()
    }

    bindPageEvent() {
        super.bindPageEvent()
    }

    /**
     * 绑定native组件各个事件
     */
    bindNativeEvent() {

    }

    initSlots() {
        super.initSlots()

    }

    /**
     * 销毁组件
     */
    destory() {
        super.destory()

    }

    /**
     * 子类需要重写该方法，以判断模板的是否成功加载
     * @returns {Promise}
     */
    _isLoadFinish() {
        return Promise.all([
            super._isLoadFinish(),
        ])
    }
}